import { atom } from 'nanostores';
export const $preNeedWidget = atom(false);
